import {EstabelecimentoModel} from '../../estabelecimento.model';
import * as moment from 'moment';

export class RascDadosIndigenasModel {
    aldeia: string;
    dataAtualizacao: string;
    dataCompetenciaFim: string;
    dataCompetenciaInicio: string;
    dsei: string;
    nomeAldeia: string;
    nomeDsei: string;
    nomePoloBase: string;
    poloBase: string;
    usuario: string;

    constructor(estabelecimento: EstabelecimentoModel) {
        const complementar = estabelecimento.identificacao.complementar;

        this.aldeia = complementar ? complementar.idAldeia : '';
        this.dataAtualizacao = moment().format('DD/MM/YYYY');
        this.dataCompetenciaFim = '';
        this.dataCompetenciaInicio = '';
        this.dsei = complementar ? complementar.idDsei : '';
        this.nomeAldeia = complementar ? complementar.aldeia : '';
        this.nomeDsei = complementar ? complementar.dsei : '';
        this.nomePoloBase = complementar ? complementar.poloBase : '';
        this.poloBase = complementar ? complementar.idPoloBase : '';
        this.usuario = '';
    }
}
